import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import "./LocationLabel.css";

// Hardcoded tooltips (static)
const tooltips = [
  { name: "Main Road", coords: "project6BaseCoords", className: "project-8-label", transform: "translate(-50%, -100%)", isBold: true },

  { name: "🌉", coords: "c18", className: "project-5-label" },
  { name: "🏡", coords: "c5", className: "i-label" },
  { name: "🏟️", coords: "c7", className: "i-label" },
];

// Hardcoded plots (hover labels for desktop only)
const plots = [
  { name: "Plot 5A", x: 1729, y: 2127, dataKey: "plot-5A" },
  { name: "Plot 20A", x: 2550, y: 2225, dataKey: "plot-20A" },
  { name: "Plot 14/9", x: 1491, y: 3336, dataKey: "plot-14/9" },
  { name: "Plot 14/10", x: 1503, y: 3428, dataKey: "plot-14/10" },
  { name: "Plot 14/11", x: 1473, y: 3165, dataKey: "plot-14/11" },
  { name: "Plot 14/12", x: 1477, y: 2125, dataKey: "plot-14/12" },
  { name: "Plot 14/13", x: 1477, y: 2205, dataKey: "plot-14/13" },
  { name: "Plot 14/14", x: 1477, y: 2277, dataKey: "plot-14/14" },
  { name: "Plot 15/3", x: 1933, y: 1291, dataKey: "plot-15/3" },
  { name: "Plot 15/4", x: 1722, y: 1287, dataKey: "plot-15/4" },
  { name: "Plot 15/5", x: 1709, y: 1559, dataKey: "plot-15/5" },
  { name: "Plot 1", x: 1709, y: 1850, dataKey: "plot-1" },
  { name: "Plot 2", x: 1923, y: 1847, dataKey: "plot-2" },
  { name: "Plot 3", x: 1720, y: 1981, dataKey: "plot-3" },
  { name: "Plot 4", x: 1925, y: 1977, dataKey: "plot-4" },
  { name: "Plot 5", x: 1722, y: 2053, dataKey: "plot-5" },
  { name: "Plot 6", x: 1926, y: 2108, dataKey: "plot-6" },
  { name: "Plot 7", x: 1731, y: 2200, dataKey: "plot-7" },
  { name: "Plot 8", x: 1929, y: 2189, dataKey: "plot-8" },
  { name: "Plot 9", x: 1931, y: 2268, dataKey: "plot-9" },
  { name: "Plot 10", x: 1735, y: 2275, dataKey: "plot-10" },
  { name: "Plot 11", x: 2157, y: 1844, dataKey: "plot-11" },
  { name: "Plot 12", x: 2157, y: 1966, dataKey: "plot-12" },
  { name: "Plot 13", x: 2158, y: 2085, dataKey: "plot-13" },
  { name: "Plot 14", x: 2157, y: 2206, dataKey: "plot-14" },
  { name: "Plot 15", x: 2418, y: 1840, dataKey: "plot-15" },
  { name: "Plot 16", x: 2419, y: 1982, dataKey: "plot-16" },
  { name: "Plot 17", x: 2417, y: 2177, dataKey: "plot-17" },
  { name: "Plot 18", x: 2609, y: 1840, dataKey: "plot-18" },
  { name: "Plot 19", x: 2550, y: 1980, dataKey: "plot-19" },
  { name: "Plot 20", x: 2552, y: 2124, dataKey: "plot-20" },
  { name: "Plot 21", x: 1741, y: 2399, dataKey: "plot-21" },
  { name: "Plot 22", x: 1747, y: 2536, dataKey: "plot-22" },
  { name: "Plot 23", x: 1758, y: 2670, dataKey: "plot-23" },
  { name: "Plot 24", x: 1767, y: 2805, dataKey: "plot-24" },
  { name: "Plot 25", x: 1773, y: 2941, dataKey: "plot-25" },
  { name: "Plot 26", x: 1936, y: 2381, dataKey: "plot-26" },
  { name: "Plot 27", x: 1943, y: 2516, dataKey: "plot-27" },
  { name: "Plot 28", x: 1949, y: 2607, dataKey: "plot-28" },
  { name: "Plot 29", x: 1954, y: 2699, dataKey: "plot-29" },
  { name: "Plot 30", x: 1959, y: 2787, dataKey: "plot-30" },
  { name: "Plot 31", x: 1967, y: 2887, dataKey: "plot-31" },
  { name: "Plot 32", x: 1954, y: 2971, dataKey: "plot-32" },
  { name: "Plot 33", x: 2160, y: 2361, dataKey: "plot-33" },
  { name: "Plot 34", x: 2172, y: 2578, dataKey: "plot-34" },
  { name: "Plot 35", x: 2177, y: 2674, dataKey: "plot-35" },
  { name: "Plot 36", x: 2181, y: 2767, dataKey: "plot-36" },
  { name: "Plot 37", x: 2186, y: 2848, dataKey: "plot-37" },
  { name: "Plot 38", x: 2191, y: 2928, dataKey: "plot-38" },
  { name: "Plot 39", x: 2420, y: 2334, dataKey: "plot-39" },
  { name: "Plot 40", x: 2433, y: 2506, dataKey: "plot-40" },
  { name: "Plot 41", x: 2438, y: 2633, dataKey: "plot-41" },
  { name: "Plot 42", x: 2450, y: 2776, dataKey: "plot-42" },
  { name: "Plot 43", x: 2568, y: 2546, dataKey: "plot-43" },
  { name: "Plot 44", x: 2574, y: 2713, dataKey: "plot-44" },
  { name: "Plot 45", x: 1789, y: 3107, dataKey: "plot-45" },
  { name: "Plot 46", x: 1910, y: 3086, dataKey: "plot-46" },
  { name: "Plot 47", x: 2043, y: 3059, dataKey: "plot-47" },
  { name: "Plot 48", x: 2199, y: 3032, dataKey: "plot-48" },
  { name: "Plot 49", x: 2332, y: 3201, dataKey: "plot-49" },
  { name: "Plot 50", x: 2456, y: 2985, dataKey: "plot-50" },
  { name: "Plot 51", x: 2588, y: 2961, dataKey: "plot-51" },
  { name: "Plot 52", x: 1815, y: 3300, dataKey: "plot-52" },
  { name: "Plot 53", x: 1923, y: 3280, dataKey: "plot-53" },
  { name: "Plot 54", x: 2049, y: 3258, dataKey: "plot-54" },
  { name: "Plot 55", x: 2209, y: 3229, dataKey: "plot-55" },
  { name: "Plot 56", x: 2318, y: 3208, dataKey: "plot-56" },
  { name: "Plot 57", x: 2435, y: 3186, dataKey: "plot-57" },
  { name: "Plot 58", x: 2565, y: 3386, dataKey: "plot-58" },
  { name: "Plot 59", x: 2665, y: 3143, dataKey: "plot-59" },
  { name: "Plot 60", x: 2778, y: 3123, dataKey: "plot-60" },
  { name: "Plot 61", x: 1847, y: 3537, dataKey: "plot-61" },
  { name: "Plot 62", x: 1957, y: 3520, dataKey: "plot-62" },
  { name: "Plot 63", x: 2086, y: 3500, dataKey: "plot-63" },
  { name: "Plot 64", x: 2222, y: 3478, dataKey: "plot-64" },
  { name: "Plot 65", x: 2329, y: 3461, dataKey: "plot-65" },
  { name: "Plot 66", x: 2436, y: 3446, dataKey: "plot-66" },
  { name: "Plot 67", x: 2545, y: 3427, dataKey: "plot-67" },
  { name: "Plot 68", x: 2650, y: 3412, dataKey: "plot-68" },
  { name: "Plot 69", x: 2781, y: 3389, dataKey: "plot-69" },
  { name: "Plot 70", x: 2155, y: 1674, dataKey: "plot-70" },
  { name: "Plot 71", x: 2156, y: 1598, dataKey: "plot-71" },
  { name: "Plot 72", x: 2154, y: 1467, dataKey: "plot-72" },
  { name: "Plot 73", x: 2153, y: 1358, dataKey: "plot-73" },
  { name: "Plot 74", x: 2152, y: 1204, dataKey: "plot-74" },
  { name: "Plot 75", x: 2348, y: 1300, dataKey: "plot-75" },
  { name: "Plot 76", x: 2349, y: 1465, dataKey: "plot-76" },
  { name: "Plot 77", x: 2348, y: 1571, dataKey: "plot-77" },
  { name: "Plot 78", x: 2352, y: 1680, dataKey: "plot-78" },
  { name: "Plot 79", x: 3175, y: 3097, dataKey: "plot-79" },
  { name: "Plot 80", x: 3312, y: 2987, dataKey: "plot-80" },
  { name: "Plot 81", x: 3412, y: 2952, dataKey: "plot-81" },
  { name: "Plot 82", x: 3510, y: 2934, dataKey: "plot-82" },
  { name: "Plot 83", x: 3638, y: 2905, dataKey: "plot-83" },
  { name: "Plot 84", x: 3766, y: 2882, dataKey: "plot-84" },
  { name: "Plot 85", x: 3896, y: 2856, dataKey: "plot-85" },
  { name: "Plot 86", x: 3769, y: 2699, dataKey: "plot-86" },
  { name: "Plot 87", x: 3606, y: 2717, dataKey: "plot-87" },
  { name: "Plot 88", x: 3473, y: 2799, dataKey: "plot-88" },
  { name: "Plot 89", x: 1477, y: 1049, dataKey: "plot-89" },
  { name: "Plot 90", x: 1527, y: 3651, dataKey: "plot-90" },
  { name: "Plot 91", x: 1478, y: 1523, dataKey: "plot-91" },
  { name: "Plot 92", x: 1402, y: 2568, dataKey: "plot-92" },
  { name: "Plot 93", x: 1458, y: 3038, dataKey: "plot-93" },
  { name: "Plot 94", x: 1384, y: 2397, dataKey: "plot-94" }
];

// Hardcoded plot centers
const plotCenters = [
  
];


const LocationLabels = ({ labelStyle, getResponsivePosition, coords, hoveredPlotId, onC5Click, onC7Click }) => {
  const [plotStatuses, setPlotStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  // Hover highlight is now driven by the SVG overlay in Map.jsx via hoveredPlotId.
  // Tolerate the slash/dash difference between the SVG plot ids and the label dataKeys.
  const normalizeKey = (key) => String(key || "").replace(/\//g, "-");
  const hoveredPlot =
    plots.find((p) => normalizeKey(p.dataKey) === normalizeKey(hoveredPlotId)) || null;

  useEffect(() => {
    const fetchPlotStatuses = async () => {
      try {
        const plotsCollection = collection(db, "prakruthiplots");
        const plotsSnapshot = await getDocs(plotsCollection);
        const statusMap = plotsSnapshot.docs.reduce((acc, doc) => {
          const data = doc.data();
          acc[doc.id] = data.Status || "Unknown";
          return acc;
        }, {});
        setPlotStatuses(statusMap);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching plot statuses from Firestore:", error);
        setPlotStatuses({});
        setLoading(false);
      }
    };

    fetchPlotStatuses();
  }, []);

  if (loading) {
    return null; // Render nothing while loading
  }

  return (
    <>
      {tooltips.map((tooltip, index) => {
        const coord = coords[tooltip.coords];
        if (!coord) return null;

        return (
          <div
            key={`tooltip-${index}`}
            className={`persistent-tooltip ${tooltip.className}`}
            onClick={(e) => {
              e.stopPropagation();
              if (tooltip.coords === "c5" && onC5Click) onC5Click();
              else if (tooltip.coords === "c7" && onC7Click) onC7Click();
            }}
            style={{
              ...labelStyle,
              ...getResponsivePosition(coord.x, coord.y),
              transform: tooltip.transform || "none",
              border: tooltip.border || "none",
              cursor: tooltip.coords === "c5" || tooltip.coords === "c7" ? "pointer" : "default",
            }}
          >
            {tooltip.isBold ? (
              <strong>
                {tooltip.name}
                {tooltip.description && <span dangerouslySetInnerHTML={{ __html: tooltip.description }} />}
              </strong>
            ) : (
              <>
                {tooltip.name}
                {tooltip.description && <span dangerouslySetInnerHTML={{ __html: tooltip.description }} />}
              </>
            )}
          </div>
        );
      })}

      {!loading &&
        plotCenters.map((plot, index) => {
          const status = plotStatuses[plot.id] || "Unknown";
          if (status === "Available") return null;

          let backgroundColor;
          if (status === "Sold") backgroundColor = "red";
          else if (status === "Booked") backgroundColor = "orange";
          else backgroundColor = "rgba(36, 35, 35, 0.8)";

          return (
            <div
              key={`plot-center-${index}`}
              className="plot-center-label"
              style={{
                ...labelStyle,
                ...getResponsivePosition(plot.x, plot.y),
                transform: "translate(-50%, -50%)",
                fontSize: "2px",
                color: "White",
                backgroundColor: backgroundColor,
                padding: "1px",
                borderRadius: "1px",
       
              }}
            >
              {`${plot.alt}`}
              <br />
              {`${status}`}
            </div>
          );
        })}

      {!isTouchDevice && hoveredPlot && (
        <div
          className="plot-hover-label"
          style={{
            ...labelStyle,
            ...getResponsivePosition(hoveredPlot.x, hoveredPlot.y),
            transform: "translate(-50%, -50%)",
          }}
        >
          {hoveredPlot.name}
        </div>
      )}
    </>
  );
};

export default LocationLabels;